const Client = require("../modules/ModHttpsClient")

module.exports = {
    loadConfig(url) {
        return Client.get([
            {
                key: "url",
                value: url
            }
        ], {
            path: "/cc/config/load"
        })
    },
    loadDefaults() {
        return Client.get(null, { path: "/cc/config/defaults/read" })
    },
    updateDefaults(data){
        return Client.post(data,{
            path:"/cc/config/defaults/update"
        })
    },
    loadProjectDefaults() {
        return Client.get(null, { path: "/cc/config/defaults/project/read" })
    },
    updateProjectDefaults(data){
        return Client.post(data,{
            path:"/cc/config/defaults/project/update"
        })
    }
}